export default __webpack_public_path__ + "img/logo-dmca.38076d4.svg";